import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AuthService } from './services/auth.service';
import { LoaderService } from './services/loader.service';
import { SharedService } from './services/shared.service';
import { SidenavService } from './services/sidenav.service';
import { ToastService } from './services/toast.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  @HostListener('window:resize', [])
  checkPixelRatioForHtmlFontSize() {
    const scalingFactor = window.devicePixelRatio;
    if (scalingFactor > 1.25) {
      document.documentElement.style.fontSize = '12px';
    } else if (scalingFactor > 1) {
      document.documentElement.style.fontSize = '10px';
    } else {
      document.documentElement.style.removeProperty('font-size');
    }
  }

  private userSessionSubscription: Subscription = new Subscription();

  constructor(
    public readonly loaderService: LoaderService,
    public readonly sidenavService: SidenavService,
    public readonly authService: AuthService,
    public readonly toastService: ToastService,
    public sharedService: SharedService,
    private readonly translateService: TranslateService,
  ) {
    this.translateService.setDefaultLang('en');
    // console.log("%cENVIRONMENT", "text-transform: uppercase; color: blue; font-weight: bold;", environment)
  }

  ngOnInit() {
    this.userSessionSubscription = this.authService.userSession$.subscribe(session => {
      // session && console.log(session);
    });
    this.checkPixelRatioForHtmlFontSize();
  }

  ngOnDestroy(): void {
    this.userSessionSubscription.unsubscribe();
  }
}
